import Layout from "../../../../layout";
import "./profile.css";
import { Link } from "react-router-dom";
import Breadcrumb from "antd/lib/breadcrumb";
import Chart from "react-apexcharts";
import Select from "antd/lib/select";
import ImageIcon from "../../../../assets/icons/imageIcon";
import DoneIcon from "../../../../assets/icons/doneIcon";
import Avatar from "../../../../assets/images/avatar.png";

const Profile = () => {
  const { Option } = Select;
  const handleChange = (value) => {
    console.log(`Selected: ${value}`);
  };
  const donutOptions = {
    chart: {
      type: "radialBar",
      offsetY: 0,
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -180,
        endAngle: 180,
        hollow: {
          size: "58%",
          background: "transparent",
        },
        track: {
          background: "#E8E7E7",
          strokeWidth: "100%",
        },
        dataLabels: {
          show: true,
          name: {
            show: false,
          },
          value: {
            fontSize: "18px",
            fontWeight: "bold",
            color: "#2E2E2E",
            formatter: function (val) {
              return val + "%";
            },
            offsetY: 10,
          },
        },
        strokeWidth: "100%",
      },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
      active: {
        filter: {
          type: "none",
        },
      },
    },
    fill: {
      type: "solid",
      colors: ["var(--green)"],
    },
    stroke: {
      lineCap: "round",
    },
    labels: ["Progress"],
  };

  const donutSeries = [70];
  return (
    <Layout>
      <div className="profile">
        {/* heaer_members */}
        <div className="heaer_profile">
          <Breadcrumb
            separator="/"
            className="custom-breadcrumb"
            items={[
              {
                title: (
                  <Link to={"/dashboard"} style={{ color: "var(--second)" }}>
                    Dashboard
                  </Link>
                ),
              },
              {
                title: (
                  <Link
                    to={"/dashboard/members"}
                    style={{ color: "var(--second)" }}
                  >
                    Members{" "}
                  </Link>
                ),
              },
              {
                title: (
                  <Link
                    to={"dashboard/members/profile"}
                    style={{ color: "var(--text)", fontWeight: "bold" }}
                  >
                    Student Profile
                  </Link>
                ),
              },
            ]}
          />
        </div>
        <div className="profile_body">
          {/* overall_progress_chart */}
          <div className="overall_progress_chart">
            <div>
              <Chart
                options={donutOptions}
                series={donutSeries}
                type="radialBar"
                height="100%"
                width="100%"
              />
            </div>
            <div>
              <span>Overall Progress</span>
              <p>2 courses</p>
            </div>
          </div>
          <div className="overall_progress_chart_mobile">
            <div className="user_profile_container">
              <div>
                <img src={Avatar} />
                <div>
                  <h3>Michael Smith</h3>
                  <p>michaelsmith12@gmail.com</p>
                </div>
              </div>
              <div>
                <span>2 Courses Enrolled</span>
                <span>23 Review</span>
              </div>
            </div>
            <div className="user_profile_chart">
              <div>
                <p> Overall Progress</p>
                <span>2 courses </span>
              </div>
              <div>
                <Chart
                  options={donutOptions}
                  series={donutSeries}
                  type="radialBar"
                  height="100%"
                  width="100%"
                />
              </div>
            </div>
          </div>
          {/* student_profile */}
          <div className="student_profile">
            {/* student_profile_left */}
            <div className="student_profile_left">
              <div className="course_name">
                <label>Course name</label>
                <Select onChange={handleChange} placeholder="Year">
                  <Option value="1">Haircut advanced</Option>
                  <Option value="2">2</Option>
                  <Option value="3">3</Option>
                </Select>
              </div>
              <div className="overall_progress">
                <div>
                  <span>Overall progress</span>
                  <span>17%</span>
                </div>
                <div className="overall_progress_bar">
                  <div></div>
                </div>
              </div>
              <div className="lists">
                <div>
                  <span>Introduction</span>
                  <span>63%</span>
                </div>
                <div>
                  <span>Fundamentals</span>
                  <span>4%</span>
                </div>
                <div>
                  <span>Advanced tip</span>
                  <span>82%</span>
                </div>
                <div>
                  <span>Course wrap up</span>
                  <span>65%</span>
                </div>
                <div>
                  <span>Course wrap up</span>
                  <span>0%</span>
                </div>
                <div>
                  <span>Number 1</span>
                  <span>0%</span>
                </div>
                <div>
                  <span>Number 1</span>
                  <span>0%</span>
                </div>
                <div>
                  <span>Number 1</span>
                  <span>0%</span>
                </div>
                <div>
                  <span>Number 1</span>
                  <span>0%</span>
                </div>
              </div>
            </div>
            {/* student_profile_right */}
            <div className="student_profile_right">
              <div className="student_profile_right_content">
                <ImageIcon />
                <div>
                  <h3>Tell me about youself</h3>
                  <div>
                    <div className="student_profile_right_bar">
                      <div></div>
                    </div>
                    <span>17%</span>
                  </div>
                </div>
              </div>
              <div className="student_profile_right_content">
                <ImageIcon />
                <div>
                  <h3>Tell me about youself</h3>
                  <div>
                    <div className="student_profile_right_bar">
                      <div></div>
                    </div>
                    <DoneIcon />
                  </div>
                </div>
              </div>
              <div className="student_profile_right_content">
                <ImageIcon />
                <div>
                  <h3>Tell me about youself</h3>
                  <div>
                    <div className="student_profile_right_bar">
                      <div></div>
                    </div>
                    <DoneIcon />
                  </div>
                </div>
              </div>
              <div className="student_profile_right_content">
                <ImageIcon />
                <div>
                  <h3>Welcome to course</h3>
                  <div>
                    <div className="student_profile_right_bar">
                      <div></div>
                    </div>
                    <span>74%</span>
                  </div>
                </div>
              </div>
              <div className="student_profile_right_content">
                <ImageIcon />
                <div>
                  <h3>Welcome to course</h3>
                  <div>
                    <div className="student_profile_right_bar">
                      <div></div>
                    </div>
                    <span>74%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
